import React from 'react';
import { Link } from 'react-router-dom';
import { team } from '../data/mock';
import { Target, Users, Award, TrendingUp } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Target className="w-8 h-8 text-[#D4AF37]" />,
      title: 'Консултантски подход',
      description: 'Поставяме интересите на клиента на първо място и предлагаме решения, базирани на дълбок анализ.'
    },
    {
      icon: <Users className="w-8 h-8 text-[#D4AF37]" />,
      title: 'Прозрачност',
      description: 'Ясна комуникация и пълна прозрачност на всеки етап от процеса.'
    },
    {
      icon: <Award className="w-8 h-8 text-[#D4AF37]" />,
      title: 'Експертиза',
      description: 'Дългогодишен опит и дълбоко познаване на имотния пазар и инвестициите.'
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-[#D4AF37]" />,
      title: 'Резултати',
      description: 'Фокус върху измерими резултати и дългосрочна стойност за клиентите.'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20">
      {/* Hero Section */}
      <section className="container-luxury mb-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#111111] border border-[#D4AF37]/20 rounded-full mb-8">
            <span className="text-sm text-[#D4AF37] font-medium tracking-wider">ЗА НАС</span>
          </div>
          
          <h1 className="heading-luxury mb-6">
            <span className="gradient-text">Информираният избор</span> в недвижимите имоти
          </h1>
          
          <p className="text-xl text-[#A9A9A9] leading-relaxed">
            Deus Estate е създадена с мисията да предостави на клиентите си не просто услуга, 
            а цялостен консултантски подход, базиран на прозрачност, експертиза и доказуемост.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="container-luxury mb-24">
        <div className="bg-gradient-to-br from-[#111111] via-[#0B0B0B] to-[#111111] border border-[#D4AF37]/20 rounded-2xl p-12 lg:p-16">
          <h2 className="text-3xl font-serif font-semibold text-[#F6F2E8] text-center mb-8">
            Нашата мисия
          </h2>
          <div className="max-w-3xl mx-auto space-y-6 text-lg text-[#A9A9A9] leading-relaxed">
            <p>
              В свят, където имотният пазар често е непрозрачен и объркващ, ние вярваме, 
              че всеки клиент заслужава достъп до пълна информация и експертен анализ.
            </p>
            <p>
              Нашият подход се основава на три стълба: <span className="text-[#D4AF37] font-semibold">детайлен анализ</span>, 
              {' '}<span className="text-[#D4AF37] font-semibold">правна сигурност</span> и 
              {' '}<span className="text-[#D4AF37] font-semibold">финансова оптимизация</span>.
            </p>
            <p>
              Работим с екип от юристи, адвокати и финансови експерти, и поддържаме 
              партньорства с 13 водещи банки, за да осигурим на клиентите си най-добрите условия.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="container-luxury mb-24">
        <h2 className="text-3xl font-serif font-semibold text-[#F6F2E8] text-center mb-12">
          Нашите принципи
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="card-luxury text-center"
            >
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-xl flex items-center justify-center mx-auto mb-6">
                {value.icon}
              </div>
              <h3 className="text-xl font-serif font-semibold text-[#F6F2E8] mb-4">
                {value.title}
              </h3>
              <p className="text-[#A9A9A9] leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      <section className="container-luxury mb-24">
        <h2 className="text-3xl font-serif font-semibold text-[#F6F2E8] text-center mb-12">
          Запознайте се с екипа
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {team.map((member, index) => (
            <div 
              key={index}
              className="card-luxury"
            >
              {/* Image Placeholder */}
              <div className="w-40 h-40 mx-auto mb-6 bg-gradient-to-br from-[#D4AF37] to-[#B8892E] rounded-full flex items-center justify-center overflow-hidden">
                <div className="w-full h-full flex items-center justify-center bg-[#111111]/80">
                  <span className="text-5xl font-serif font-bold text-[#D4AF37]">
                    {member.name.charAt(0)}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="text-2xl font-serif font-semibold text-[#F6F2E8] mb-2">
                  {member.name}
                </h3>
                <p className="text-[#D4AF37] font-medium mb-6 tracking-wide">
                  {member.position}
                </p>
                <p className="text-[#A9A9A9] leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="container-luxury">
        <div className="bg-gradient-to-br from-[#111111] via-[#0B0B0B] to-[#111111] border border-[#D4AF37]/20 rounded-2xl p-12 text-center">
          <h2 className="text-3xl lg:text-4xl font-serif font-semibold text-[#F6F2E8] mb-6">
            Готови да работим заедно?
          </h2>
          <p className="text-lg text-[#A9A9A9] mb-8 max-w-2xl mx-auto">
            Свържете се с нас и открийте как можем да ви помогнем да вземете информирано решение
          </p>
          <Link to="/contact" className="btn-primary">
            Свържете се с нас
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
